import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Namespace } from '../../../../translation/namespace';
import { GroupLabels } from '../../MainNavigationTypes';

type GroupLabelType = {
  groupLabel: GroupLabels;
};

export function GroupLabel({ groupLabel }: GroupLabelType) {
  const { t } = useSonTranslation(Namespace.MainNavigation);
  return (
    <span
      className="main-navigation__grouptitle"
      id={`mainnav-grouplabel-${groupLabel}`}
      // we decided to hide this from screen readers because
      // the visual label causes confusion as it is doubled
      // with the lists aria-label and mistaken for a nav element
      aria-hidden="true"
    >
      <span className="main-navigation__grouptitle-line">
        <span className="main-navigation__grouptitle-container">{t(`groupLabel.${groupLabel}`)}</span>
      </span>
    </span>
  );
}
